import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-13f5min-0"
})(["padding:7px 9px;cursor:pointer;font-size:14px;+ div{border-top:1px solid #eee;}&:hover{background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiLL;
});